import React, { useState, useContext, useRef } from 'react'
import styled from 'styled-components'
import { UpdateUserPremiumGoal } from '../../../../store/UserClient'
import { debounce } from 'throttle-debounce'

import CurrencyInput from 'react-currency-input-field'
import IpsaContext from '../../../../context/IpsaContext'

const PremiumGoal = () => {
    const {
        userInfo: { premiumGoal },
    } = useContext(IpsaContext)

    const Container = styled.div`
        margin: auto;
        width: 80%;
        min-width: 200px;
        height: 80%;
        text-align: center;
        font-size: 20px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        & h2 {
            font-size: 26px;
            font-weight: 500;
            margin: 0.5em;
        }

        & > .border-box {
            border: none;
            background: transparent;
        }

        & input {
            width: 60%;
            min-width: 200px;
        }

        @media (min-width: 1024px) {
            font-size: 45px;

            & h2 {
                font-size: 60px;
            }
        }
    `
    const validateValue = (value) => {
        if (value) {
            update(value)
        }
    }

    const update = useRef(
        debounce(300, (value) => {
            UpdateUserPremiumGoal(value)
        })
    ).current

    return (
        <Container>
            <div className="border-box">
                <h2>Enter your annual premium goal</h2>
            </div>
            <CurrencyInput
                placeholder="$0"
                allowDecimals={false}
                className="premiumgoalinput"
                onChange={validateValue}
                defaultValue={premiumGoal}
                prefix={'$'}
                allowNegativeValue={false}
            />
        </Container>
    )
}

export default PremiumGoal
